interface Props {
  label: string;
  score: number;
}

export function MetricBar({ label, score }: Props) {
  const color = score < 35 ? 'bg-success' : score < 65 ? 'bg-warning' : 'bg-danger';
  const text = score < 35 ? 'text-success' : score < 65 ? 'text-warning' : 'text-danger';
  const severity = score < 35 ? 'Low' : score < 65 ? 'Moderate' : 'High';

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <span className="text-body text-text-secondary">{label}</span>
        <span className={`text-caption ${text}`}>{severity}</span>
      </div>
      <div className="relative h-1 rounded-full bg-surface-raised overflow-hidden">
        <div
          className={`absolute inset-y-0 left-0 rounded-full ${color} transition-all duration-500`}
          style={{ width: `${Math.max(4, Math.min(100, score))}%` }}
        />
      </div>
    </div>
  );
}
